import { render, staticRenderFns } from "./tabWraper.vue?vue&type=template&id=a8f798cc"
import script from "./tabWraper.vue?vue&type=script&lang=js"
export * from "./tabWraper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports